import { useState } from "react";
import { Menu, X, Gift, Phone } from "lucide-react";
import { BRAND } from "@/lib/api";

const links = [
  { href: "#beneficios", label: "Beneficios" },
  { href: "#como-funciona", label: "Cómo funciona" },
  { href: "#recompensa", label: "Bono $50" },
  { href: "#preguntas", label: "Preguntas" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 glass border-b border-slate-200/80" data-testid="site-header">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between gap-4">
        <a href="#inicio" className="flex items-center gap-3" data-testid="header-logo-link">
          <img
            src={BRAND.logo}
            alt={`${BRAND.name} logo`}
            className="h-11 w-11 rounded-xl object-cover shadow-md ring-1 ring-slate-200"
          />
          <div className="leading-tight">
            <p className="font-heading font-extrabold text-navy text-base sm:text-lg tracking-tight">
              {BRAND.name}
            </p>
            <p className="text-[10px] tracking-[0.18em] font-semibold text-growth hidden sm:block">
              {BRAND.badge}
            </p>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8" data-testid="header-nav">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-slate-600 hover:text-brand-blue transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <span
            className="inline-flex items-center gap-1.5 rounded-full bg-[var(--gold-50)] text-amber-800 text-xs font-bold px-3 py-1.5 border border-amber-200"
            data-testid="header-reward-badge"
          >
            <Gift className="h-3.5 w-3.5" /> $50 de descuento en auto
          </span>
          <a
            href="#formulario"
            className="btn-cta rounded-full px-5 py-2.5 text-sm font-bold"
            data-testid="header-cta-button"
          >
            Cotizar gratis
          </a>
        </div>

        <button
          className="md:hidden p-2 rounded-lg text-navy hover:bg-slate-100"
          onClick={() => setOpen(!open)}
          aria-label="Abrir menú"
          data-testid="header-mobile-menu-button"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-4 py-4 space-y-3" data-testid="header-mobile-menu">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-base font-medium text-slate-700 py-1"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#formulario"
            onClick={() => setOpen(false)}
            className="btn-cta flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-bold"
            data-testid="header-mobile-cta-button"
          >
            <Phone className="h-4 w-4" /> Quiero mi cotización gratis
          </a>
        </div>
      )}
    </header>
  );
};
